(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportDetailsController', CompanyReportDetailsController);

        CompanyReportDetailsController.$inject = ['$scope', '$state', '$uibModal', '$http', 'CompanyReportService', 'FinancialSensitivityUnlistedService','$rootScope', '$window', '$interval', '$q', 'GenericServiceNew', 'GenericService', '$timeout', 'ivhTreeviewOptions', 'ivhTreeviewBfs','FinancialSensitivityService'];

    function CompanyReportDetailsController($scope, $state, $uibModal, $http, CompanyReportService, FinancialSensitivityUnlistedService,$rootScope, $window, $interval, $q, GenericServiceNew, GenericService, $timeout, ivhTreeviewOptions, ivhTreeviewBfs,FinancialSensitivityService) {

		$scope.tabid=1;
		$scope.isfinance=false;
		$scope.companyDetails = $state.params.companyDetails ? $state.params.companyDetails : $state.go('companyreport');
		$scope.fsmDataAll = $state.params.fsmData
        $scope.dataUnits = '2';
		$scope.dataOrder = 'DESC';
		$scope.selectedFormat = 2;
		var indgri = null;
		 var idss = new Array();
		 
		$scope.companyPeers =  $state.params.companyPeers;
		$scope.remainigPeers = $state.params.remainigPeers;
        $scope.companyObj = $state.params.companyObj;
		$scope.industryLevel = $state.params.industryLevel;
		localStorage.setItem('companyPeers',$state.params.companyPeers[0]);
		$scope.scorecardFileName = '';
//		$scope.filters = {
//				selectedirsCompanies : []
//		}
		
		$scope.filters = {};
		$scope.filters = 'Select IRS Industry';
		$scope.irsNameList=$state.params.companyObj.irsIndustryNames;
		$scope.templateJson = $state.params.templateJson ? JSON.parse($state.params.templateJson) : undefined;
		$scope.templateName = $state.params.templateName ? $state.params.templateName : undefined;
		$scope.consolidationFlag = $scope.companyDetails.availableScorecardParam ? 
										$scope.companyDetails.availableScorecardParam.indexOf('N') >= 0 ? 'N' : $scope.companyDetails.availableScorecardParam.indexOf('Y') >= 0 : undefined;
		$scope.reportType = $state.params.reportType;
		$scope.isBobUser = $state.params.isBobUser;
		console.log("bobuser" + $scope.isBobUser);
		$scope.canceler = $q.defer();
		$scope.screenWidth = document.documentElement.clientWidth;
		var industryGrid = null;
		var arrayind = [];
		$scope.selectedIndustries = [];
		$scope.selectedIndustries.push(
			$scope.companyDetails.industryFiveDetail.split('_$$$$')[1]
		);
		
	//	$scope.badgeStringind = $scope.selectedIndustries[0].substr(0,14);
		$scope.badgeStringind = $scope.selectedIndustries[0];
		$scope.selectedIndId = $scope.companyDetails.industryFiveDetail.split('_$$$$')[0];
		$scope.childIds = [];
		$scope.childIds.push($scope.selectedIndId);
		var indfiltervaluchanged = false;
		$scope.showMorePeers = false;
		$scope.peerCodes = $scope.companyDetails.peerCodes;

		angular.forEach($scope.irsNameList, function(val, key) {
	   
	   if($scope.companyDetails.irsCode.indexOf(val.labelName) > -1){
		   
	//	 $scope.filters.selectedirsCompanies.push({"id":val.id,"name":val.name,"labelName":val.labelName,checked:true});
			 $scope.filters= val.labelName;
		   
	   }
			});
		
		if($scope.reportType == 3 || $scope.reportType == 9) {
			var company = {
				"companyCode" : $scope.companyObj.companyCode,
				"companyName": $scope.companyObj.companyName,
				"financialsDataUnit": $scope.dataUnits,
				"financialsDataOrder": $scope.dataOrder,
				"reportFormat": parseInt($scope.selectedFormat),
				"reportType": $scope.reportType,
				"irsIndCode" : $scope.filters,
				"fsmAvailableFlag": $scope.isfsmAvFlag,
				"fsmExcelPath": $scope.excelPathForFsm,
				"fsmTemplatePath": $scope.fsmTemplatePath
			}
			CompanyReportService.saveScorecardDataToJson(company).then(
				function(success) {
					console.log(success);
					$scope.scorecardFileName = success;
				}, function(error) {

				}
			)
		}

		$scope.setPeer = function() {
			for (var index = 0; index < $scope.companyPeers.length; index++) {
				if(index == 0) {
					$scope.peerOneCompany = $scope.companyPeers[index];
				} else if(index == 1) {
					$scope.peerTwoCompany = $scope.companyPeers[index];
				} else if(index == 2) {
					$scope.peerThreeCompany = $scope.companyPeers[index];
				}
			}
			$scope.savedPeerNames = $scope.companyPeers;
			$scope.peerFourCompany = '';
			$scope.peerFiveCompany = '';
		}
		$scope.setPeer(); 
		var indfiltervaluchanged = false;
		var firstcharind = '';

	    if($scope.templateJson) {
			if($scope.templateJson.template.peerBenchmarking) {
				$scope.templateJson.template.peerBenchmarking.peerGroup = $scope.companyDetails.peerCodes;
				$scope.savedPeers = $scope.companyDetails.peerCodes;
				localStorage.setItem('companyDetails', JSON.stringify($scope.companyDetails));
			} 
		} else if($scope.reportType == '5' ) {
			$scope.savedPeers = $scope.companyDetails.peerCodes;
			localStorage.setItem('companyDetails', JSON.stringify($scope.companyDetails));
		}
		//TaskId 51974
		$scope.indFlag = false;
		var vm = this;
		$scope.nextscore = true;
		$scope.validation = false;
		$scope.peerGroupMSTPrimaryKeyId = null;
		$scope.years = [];
		$scope.defaultIds = [];
		var uploadedlistGrid = '';
		var peerlistGrid = '';
		$scope.locationval = null;
		$scope.industryval = null;
		$scope.generateradio = true;
		var message = null;
		$scope.iferrorindustry = false;
		$scope.errorIndustryMessages = null;
		$scope.iferrorlocation = false;
		$scope.errorLocationMessages = null;
		$scope.iferrorcompname = false;
		$scope.errorcompnameMessage = null;
		$scope.iferrorpeerloc = false;
		$scope.errorpeerlocMessages = null;
		$scope.ParameterDTO = {};

		$scope.tempIndustryIdArr = [];
		$scope.tempIndustryNameArr = [];

		$('#industrytreegrid').hide();

		// Industry Benchmarking Functionality methods
		$scope.setInnerTabSetData = function(tabid) {
			$scope.currentTab = tabid;
			if ($scope.currentTab == 1 && $scope.isSubscribed == false) {
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "This section is not available in your current subscription. To subscribe to the  latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
			} else {
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "";

			}
			if($scope.currentTab == 1){
				$rootScope.$broadcast('myCustomEventNonFin', function(event, data) {});
				$scope.isfinance = false;
				$scope.setSelectedTab();
			}
			if($scope.currentTab == 2){
				$rootScope.$broadcast('myCustomEventFin', function(event, data) {});
				// $scope.currentTab = 2;
				$scope.isfinance = true;
				$scope.setSelectedTab();
			}
			

		}

		$scope.setSelectedTab = function() {

			$scope.peerGroupTwoAddedFlag = true;
			$scope.peerGroupFourAddedFlag = false;
			$scope.peerGroupThreeAddedFlag = false;
			$scope.temptab = angular.copy($scope.currentTab);
			$scope.activeListStatus(1);
			$scope.selectedPeerGroups = [];

			$scope.showResult = false;
			$scope.filterCriteriaFlag = true;
			$scope.tabid = $scope.temptab;
			$scope.setActiveClasses();
			// $scope.validateData($scope.tabid);

			// added for unchecking peergroup
			$scope.peerGroupOneCheckedFlag = true;
			$scope.peerGroupTwoCheckedFlag = false;
			$scope.peerGroupThreeCheckedFlag = false;
			$scope.peerGroupFourCheckedFlag = false;

			// added for load directive
			$scope.isdeleted1 = true;
			$scope.isdeleted2 = false;
			$scope.isdeleted3 = false;
			$scope.isdeleted4 = false;

			if ($scope.tabid == 1) {
				// $scope.getSelectedRange();

			}

		}

		$scope.setActiveClasses = function() {
			if ($scope.temptab == 1) {
				$("#toptab1").addClass("active");
			} else {
				$("#toptab1").removeClass("active");
			}

			if ($scope.temptab == 2) {
				$("#toptab2").addClass("active");
			} else {
				$("#toptab2").removeClass("active");
			}

		}
		
		$scope.activeListStatus = function(peerNumber) {
			$("#tabListContainer li").removeClass('active');
			$("#peerGroupTabContainer .peerGroupTabContainer").removeClass(
					'in active');

			$("#peerGroupHeading" + peerNumber).addClass('active');
			$("#peerGroup" + peerNumber).addClass('in active');
		}

		// $scope.additionalFilterCriteriaFlag = true;
		// $scope.openAdditionalInputFilterContainer = function() {
		// 	if ($scope.additionalFilterCriteriaFlag) {
		// 		$scope.additionalFilterCriteriaFlag = false;
		// 	} else {
		// 		$scope.additionalFilterCriteriaFlag = true;
		// 	}
		// }

		// Industry Benchmarking Functionality method end


		$scope.getPeerOne = function() {
			if($scope.peerOneCompany != localStorage.getItem('companyPeers') && $scope.peerOneCompany != '') {
				return $scope.peerOneCompany;
			} else {
				return localStorage.getItem('companyPeers');
			}
		}

		$scope.ind = {
			indstatus : false
		};
		var click = 0;
		$scope.segmentFlag = "Manufacturing";
		// if($scope.companyObj.fsmFlag != undefined){
		// 	$scope.segmentFlag  = $scope.companyObj.fsmFlag ;
		// }else if($scope.companyObj.companyFlag != undefined){
		// 	$scope.segmentFlag  = $scope.companyObj.companyFlag ;
		// }
		
		var promise1 = GenericService.getMasterTreeData($scope.segmentFlag);
		promise1.then(function (data) {
		
		//var promise = GenericService.getMasterIndustryTreeDatascorecard();
	//	promise.then(function (data) {
			$scope.indTreeData = data;
			
//		}, function (response, status, headers, config) {
//			ErrorHandlerService.handleError(response, status, headers, config);
//		});
		}, function (response, status, headers, config) {
			ErrorHandlerService.handleError(response, status, headers, config);
		});
		var locationGrid = null;
		var industryGrid = null;
		var locationGridpeer = null;

		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};
		// Htmltreegrid data for location
		var clickloctree = 0;
		$scope.loc = {
			locstatus : false
		};
		
		
		$scope.getLocationTree = function() {
			$('#industrytreegrid').hide();
		$scope.locationOptions = {
				dataProvider : $scope.zonalwiseLocationData,
				delegate : $scope
			};/* },100); */
			if (clickloctree == 0) {
				$timeout(function() {
					$("#loctree")[0].click();
				}, 100);
				clickloctree++;
			}
			$scope.locTreeData = $scope.zonalwiseLocationData;

			$scope.sampletreepeerdata = $scope.zonalwiseLocationData;

		}
		
		var locfiltervaluchanged = false;
		var firstcharloc = '';

		// Changes for relative industries dropdown

		$scope.filerPageSortHandleloc = function(event) {
			setTimeout(
					function() {
						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							locfiltervaluchanged = false;

						}
						if (!locfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharloc = filter.filterExpressions[0].expression
									locfiltervaluchanged = true;
									$scope
											.onLocationGridCreationCompleted(null);
								}
							}
						}
					}, 1);
		};

		$scope.onLocationGridCreationCompleted = function(event) {
			if (event != null) {
				locationGrid = event.target;
				locationGrid.enableHeightAutoAdjust = true;
				locationGrid.setSelectionMode("singleRow");
				locationGrid.validateNow();
			} else {
				locationGrid.enableHeightAutoAdjust = true;
				locationGrid.clearFilter();
				locationGrid.expandAll();
				locationGrid
						.setFilterValue('label', firstcharloc, locationGrid);
				locationGrid.validateNow();
			}

		};
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.onLocationDynamicLevelCreated = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		$scope.selectAllflag = false;
		$scope.selectAll = function(flag) {
			if(null != locationGrid){
				
				locationGrid.collapseAll();
				locationGrid.clearSelection();
				locationGrid.clearAllFilters();
				if (flag) {
					arrayloc = []
					$scope.selectedLocation = [];
					var allkeys = [];
					$scope.selectAllflag = true;
					ivhTreeviewBfs($scope.locTreeData, opts, function(node) {
						allkeys.push(node.id);
					});

					$timeout(function() {
						locationGrid.setSelectedKeys(allkeys, false);
					}, 100);

				} else {
					arrayloc = [];
					$scope.selectedLocation = [];
					$scope.selectAllflag = false;
					locationGrid.clearSelection();

				}
			}
			
		}

		var arrayloc = [];
		$scope.selectedLocation = [];
		$scope.badgeString = '';
		$scope.setbadgesforLocation = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {
				if (arrayloc != null && arrayloc != 'null') {
					arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
				}
				$scope.nolocdata = false;
				arrayloc.push(evt.item.label);
				$scope.locationval = arrayloc.length;
				if ($scope.locationval > 0) {
					$scope.iferrorlocation = false;
				}
			} else {
				arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
			}

			$timeout(
					function() {

						$scope.selectedLocation = angular.copy(arrayloc);
						$scope.badgeString = $scope.selectedLocation.toString();

//						if ($scope.badgeString.length > 30) {
//							for (var i = 0; i < $scope.selectedLocation.length; i++) {
//								if ($scope.selectedLocation[i].length > 10) {
//									$scope.selectedLocation[i] = $scope.selectedLocation[i]
//											.substr(0, 14)
//											+ '..';
//								}
//							}
							$scope.badgeString = $scope.selectedLocation
									.toString();
//						} else {
							$scope.badgeString = $scope.selectedLocation
									.toString();
					//	}
					}, 100);

		}
		// Htmltreegrid data for location end

		// Htmltreegrid data for industry
		$scope.ind = {
			indstatus : false
		};
		var click = 0;
		$scope.iterateChildren = function(node) {
			if($scope.companyDetails.industryFiveDetail.split('_$$$$')[0] == node.id) {
				if(!$scope.selectedIndustries.includes(node.label))
					$scope.selectedIndustries.push(node.label);
					//$scope.badgeStringind = $scope.selectedIndustries[0].substr(0,14);
				$scope.badgeStringind = $scope.selectedIndustries[0];
			} else if(node.children.length > 0) {
				for (var index = 0; index < node.children.length; index++) {
					const element = node.children[index];
					$scope.iterateChildren(element);
				}
			}
		}
		$scope.getIndustryTree = function() {
			$('#locationtreegrid').hide();
			$scope.industryOptions = {
				dataProvider : $scope.indTreeData,
				delegate : $scope
			};/* },100); */
			if (click == 0) {
				$timeout(function() {
					$("#getindtree")[0].click();
				}, 100);
				click++;
			}
			//if($scope.selectedIndustries.length == 0) {
				// ivhTreeviewBfs($scope.indTreeData, opts, function(node) {
				// 	$scope.iterateChildren(node);
				// });
		
				// industryGrid.setSelectedObjects([{
				// 	id: $scope.companyDetails.industryFiveDetail.split('_$$$$')[0],
				// 	label: $scope.companyDetails.industryFiveDetail.split('_$$$$')[1]
				// }], false);
			//}
		}

		var indfiltervaluchanged = false;
		var firstcharind = '';

		$scope.filerPageSortHandle = function(event) {
			setTimeout(
					function() {

						var filter = event.target.getRootFilter();
						var grid = event.target;
						if (!filter.filterExpressions.length) {
							grid.collapseAll();
							grid.validateNow();
							indfiltervaluchanged = false;

						}else{
							grid.expandAll();
						}
						if (!indfiltervaluchanged) {
							if (event.cause == "filterChange") {
								if (filter.filterExpressions
										&& filter.filterExpressions.length) {
									firstcharind = filter.filterExpressions[0].expression
									indfiltervaluchanged = true;
									$scope
											.onindustryGridCreationCompleted(null);
								}
							}
						}
					}, 1);
		};


		$scope.disablelevelind = function(cell, data) {
			return data.children.length == 0;
		}

		$scope.disablecellind = function(cell, data) {
			return (cell.getLevel().getNestDepth() != 5);
		}

		$scope.disablecellloc = function(cell) {
			return (cell.getLevel().getNestDepth() != 3);
		}

		$scope.disablelevelloc = function(cell, data) {

			return !data.hasOwnProperty('children');
		}

		
		var firstTime = 0;
		$scope.onindustryGridCreationCompleted = function(event) {

			if (event != null) {
				industryGrid = event.target;
				industryGrid.enableHeightAutoAdjust = true;
				industryGrid.setSelectionMode("singleRow");
				industryGrid.validateNow();
			} else {
				industryGrid.enableHeightAutoAdjust = true;
				industryGrid.clearFilter();
				industryGrid.expandAll();
				industryGrid
						.setFilterValue('label', firstcharind, industryGrid);
				industryGrid.validateNow();
			}
			if(firstTime == 0) {
				ivhTreeviewBfs($scope.indTreeData, opts, function(node) {
					$scope.iterateChildren(node);
				});
				var arr = [];
				arr.push($scope.selectedIndId)
				$timeout(function() {
					industryGrid.setSelectedKeys(arr, false);
				}, 100);
				industryGrid.setSelectedObjects([{
					id: $scope.companyDetails.industryFiveDetail.split('_$$$$')[0],
					label: $scope.companyDetails.industryFiveDetail.split('_$$$$')[1]
				}], false);
				firstTime = firstTime + 1;
			}
		};

		$scope.onIndustryDynamicLevelCreated = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		$scope.selectAllindustryflag = false;
		$scope.selectAllindustry = function(flag) {
			if(null != industryGrid){
				
				industryGrid.collapseAll();
				industryGrid.clearSelection();
				industryGrid.clearAllFilters();

				if (flag) {
					arrayind = []
					$scope.selectedIndustries = [];
					var allkeys = [];
					$scope.selectAllindustryflag = true;
					ivhTreeviewBfs($scope.indTreeData, opts, function(node) {
						allkeys.push(node.id);
					});

					$timeout(function() {
						industryGrid.setSelectedKeys(allkeys, false);
					}, 100);

					industryGrid.setSelectedObjects($scope.indTreeData, false);

				} else {
					arrayind = [];
					$scope.idStack=[];
					$scope.selectedIndustries = [];
					$scope.selectAllindustryflag = false;
					industryGrid.clearSelection();
					indfiltervaluchanged = false;
					industryGrid.collapseAll();
					industryGrid.validateNow();
				}
			}
			
		}

		var arrayind = [];
		
		$scope.getChildIndustry = function(childArray) {
   				var childInd = [];
			if (childArray.children.length <= 0) {
				if($scope.idStack.indexOf(childArray.id) < 0){
				$scope.idStack.push(childArray.id);
				}
				if(!$scope.childIds.includes(childArray.id)) 
					$scope.childIds.push(childArray.id);
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					if($scope.idStack.indexOf(childArray.id) < 0){
						$scope.idStack.push(childArray.id);
						}
					$scope.getChildIndustry(childArr);
				}
			}

		}

		$scope.deleteChildIndustry = function(childArray) {
   				
			if (childArray.children.length <= 0) {
				var index = $scope.childIds.indexOf(childArray.id);
				if(arrayind.indexOf(childArray.label) > -1){
					arrayind.splice(arrayind.indexOf(childArray.label), 1)
					}
				if($scope.idStack.indexOf(childArray.id) > -1){
				$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
				}
				if (index > -1) {
					$scope.childIds.splice(index, 1);
					
				}
				return childArray.id;
			} else {
				for (var i = 0; i < childArray.children.length; i++) {
					var childArr = childArray.children[i];
					// return $scope.getChildIndustry(childArr);
					if($scope.idStack.indexOf(childArray.id) > -1){
						$scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
						}
					if(arrayind.indexOf(childArray.label) > -1){
						arrayind.splice(arrayind.indexOf(childArray.label), 1)
						}
					$scope.deleteChildIndustry(childArr);
				}
			}

		}
		$scope.idStack = [];
			idss = new Array();
			var selectedIndArray = new Array();
			$scope.selectedIndss={};
		$scope.setbadgesforindustry = function(evt) {
			$scope.peerOneCompany = '';
			$scope.peerTwoCompany = '';
			$scope.peerThreeCompany = '';
			$scope.peerFourCompany = '';
			$scope.peerFiveCompany = '';
			//$scope.childIds = [];
		//	$scope.idStack = [];
			
			var grid = evt.target;
			if (evt.isItemSelected) {
//				if (arrayind != null && arrayind != 'null') {
//					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
//				}
				$scope.noinddata = false;
				arrayind.push(evt.item.label);
				selectedIndArray.push(evt.item.label);
				
				$scope.industryval = arrayind.length;
				if ($scope.industryval > 0) {
					$scope.iferrorindustry = false;
				}

				if (evt.item.children.length > 0) {
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						var id = $scope.getChildIndustry(childArr);
						//arrayind.push(id);
						//idss.push(childArr.id);
						if($scope.idStack.indexOf(evt.item.id) < 0){
						$scope.idStack.push(evt.item.id);
						}
						if($scope.idStack.indexOf(childArr.id) < 0){
						$scope.idStack.push(childArr.id);
						}
						idss=$scope.idStack;
					}
				} else {
					//arrayind.push(evt.item.id);
					if($scope.idStack.indexOf(evt.item.id) < 0){
					//idss.push(evt.item.id);
						$scope.idStack.push(evt.item.id)
					}
					idss=$scope.idStack;
					if(!$scope.childIds.includes(evt.item.id)) 
						$scope.childIds.push(evt.item.id);
				}
			
				$scope.indFlag = false;
				console.log("event selected ",$scope.idStack);
			} else {
				if(arrayind.indexOf(evt.item.label) > -1){
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
				}
				
				if (evt.item.children.length > 0) {
					for (var i = 0; i < evt.item.children.length; i++) {
						var childArr = evt.item.children[i];
						var id = $scope.deleteChildIndustry(childArr);
						if($scope.idStack.indexOf(childArr.id) > -1){
						$scope.idStack.splice($scope.idStack.indexOf(childArr.id), 1);
						}
					
						
					}
					if($scope.idStack.indexOf(evt.item.id) > -1){
					$scope.idStack.splice($scope.idStack.indexOf(evt.item.id), 1);
					}
					if($scope.idStack.length <=1){
						$scope.idStack=[];
					}
				} else {
					var index = $scope.childIds.indexOf(evt.item.id);
					if($scope.idStack.indexOf(evt.item.id) > -1){
					$scope.idStack.splice($scope.idStack.indexOf(evt.item.id), 1);
				}
					
					if(arrayind.indexOf(evt.item.label) > -1){
						arrayind.splice(arrayind.indexOf(evt.item.label), 1)
						}
					
					if (index > -1) 
						$scope.childIds.splice(evt.item.id, 1);
				}
				idss=$scope.idStack;
				
				console.log("event unselected selected ",$scope.idStack);
			}
			$scope.selectedIndId = evt.item.id;
			if($scope.childIds.length == 0){
				$scope.selectedIndustries = [];
			}
			$timeout(
					function() {

						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringind = $scope.selectedIndustries
								.toString();
						grid.setSelectedKeys(idss, false);
						if ($scope.badgeStringind.length > 30) {
							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
								if ($scope.selectedIndustries[i].length > 10) {
									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
											.substr(0, 14)
											+ '..';
								}
							}
							$scope.badgeStringind = $scope.selectedIndustries
									.toString();
						} else {
							$scope.badgeStringind = $scope.selectedIndustries
									.toString();
						}

					}, 100);
			console.log($scope.childIds)
		}
		
		var clicklocpeer = 0;
		$scope.locpeer = {
			locstatuspeer : false
		};
		$scope.getLocationTreepeer = function(flag) {
			$scope.locpeer.locstatuspeer = true;

			/* $timeout(function(){ */$scope.locationOptionspeer = {
				dataProvider : $scope.zonalwiseLocationData,
				delegate : $scope
			};/* },100); */
			if (flag && clicklocpeer == 0) {
				$timeout(function() {
					$("#loctreepeer")[0].click();
				}, 100);
				clicklocpeer++;
			}
			$scope.locTreeDatapeer = $scope.zonalwiseLocationData;

			$scope.sampletreepeerdatapeer = $scope.zonalwiseLocationData;
		}

		$scope.validateSelections = function() {
			$scope.nocmpdata = false;
			$scope.nolocdata = false;
			$scope.noinddata = false;

			if ($scope.companyDetails.companyName == null
					|| $scope.companyDetails.companyName == "null"
					|| typeof $scope.companyDetails.companyName == "undefined"
					|| $scope.companyDetails.companyName.length == 0) {
				$scope.nocmpdata = true;
			}

			if (locationGrid.getSelectedKeys() == null
					|| locationGrid.getSelectedKeys() == "null"
					|| typeof locationGrid.getSelectedKeys() == "undefined"
					|| locationGrid.getSelectedKeys().length == 0) {
				$scope.nolocdata = true;
			}

			if (industryGrid.getSelectedKeys() == null
					|| industryGrid.getSelectedKeys() == "null"
					|| typeof industryGrid.getSelectedKeys() == "undefined"
					|| industryGrid.getSelectedKeys().length == 0) {
				$scope.noinddata = true;
			}

			if (($scope.nocmpdata || $scope.nolocdata || $scope.noinddata)) {
				$scope.iferror = true;
				$scope.errorMessages = "Please input company and select a industry and location.";

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 10000);
				return false;
			}

			return true;
		};
		// Htmltreegrid data for locationpeer end

		
		$scope.industryall = false;
		$scope.selectAllflagprod = false;
		$scope.selectAllflagloc = false;
		$scope.prodstatus = false;
		$scope.selectedsegmentsfinal = [];
		$scope.selectedProducts = [];

		var allKeysProducts = [];
		var allKeysInd = [];
		var arrayind = new Array();
		var arrayprod = new Array();
		var indgri = null;
		var prodgri = null;
		var indfiltervaluchanged = false;
		var firstcharind = '';
		var prodfiltervaluchanged = false;
		var firstcharprod = '';

		$scope.badgeStringInd = '';
		$scope.badgeStringProd = '';

		$scope.accrdn = {
			isopen : true
		};

		$scope.gettooltipforIndustry = function(item, column) {
			var html = "<label title='" + item.label + "'>" + item.label
					+ "</label>"
			return html;
		};
		$scope.ind = {
			indstatus : false
		};

		$scope.prod = {
			prodstatus : false
		};


		$scope.onDynamicLevelCind = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onDynamicLevelCprod = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onGridCreationCompletedIndustry = function(event) {
			if (event != null) {
				indgri = event.target;
				indgri.enableHeightAutoAdjust = true;
				indgri.validateNow();
			} else {
				indgri.enableHeightAutoAdjust = true;
				indgri.clearFilter();
				indgri.setFilterValue('label', firstcharind, indgri);
				indgri.validateNow();
			}
		};


		var filterselectall = false;
		// for industry tree
		$scope.selectAllind = function(flag) {
			$scope.peerOneCompany = '';
			$scope.peerTwoCompany = '';
			$scope.peerThreeCompany = '';
			$scope.peerFourCompany = '';
			$scope.peerFiveCompany = '';
			allKeysInd = [];
			$scope.idStack =[];
			$scope.childIds = [];
			if (flag) {

				$scope.indFlag = false;
				$scope.noinddata = false;
				arrayind = [];
				$scope.selectedIndustries = [];
				if (indfiltervaluchanged) {
					filterselectall = true;
					$scope.industryall = false;
				} else {
					filterselectall = false;
					$scope.industryall = true;
				}

				ivhTreeviewBfs($scope.indTreeData, opts, function(node) {
					if (indfiltervaluchanged) {
						if (node.label.toLowerCase().includes(firstcharind)) {
							$scope.selectedIndustries.push(node.label);
							allKeysInd.push(node.id);
							if (node.children.length > 0) {
								ivhTreeviewBfs(node, opts, function(childnode) {
									allKeysInd.push(childnode.id);
									arrayind.push(node.label);
									
								});
							}
						}
					} else {
						$scope.idStack = allKeysInd;
						$scope.childIds =allKeysInd;
						arrayind.push(node.label);
						allKeysInd.push(node.id);
						$scope.tempIndustryIdArr.push(node.id);
					}
				});
				
				$scope.selectedIndustries = angular.copy(allKeysInd);
				$scope.badgeStringInd = $scope.selectedIndustries.toString();
				$timeout(function() {
					industryGrid.setSelectedKeys(allKeysInd, false);
				}, 100);
			} else {
				$scope.companyDetails.industryId='';
				arrayind = [];
				$scope.selectedIndustries = [];
				$scope.industryall = false;
				industryGrid.clearSelection();
				industryGrid.clearAllFilters();
				industryGrid.clearChanges();
				indfiltervaluchanged = false;
				industryGrid.collapseAll();
				industryGrid.validateNow();
				$scope.indFlag = true;
			}
		}

		$scope.ind.indstatus = false;
		var cnt = 0;

		$scope.setIndustryTree = function() {
			$scope.ind.indstatus = true;

			$scope.gridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};
			if (cnt == 0) {
				cnt = 1;
				$timeout(function() {
					var l = document.getElementById('industryButton');
					l.click();
				}, 100, false);
			}
		}

		$scope.setbadgesforIndustry = function(evt) {
			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.indFlag = false;
				$scope.noinddata = false;
				arrayind.push(evt.item.label);
				$scope.tempIndustryIdArr.push(evt.item.id);
				$scope.tempIndustryNameArr.push(evt.item.label);
			} else {
				if (arrayind.indexOf(evt.item.label) != -1) {
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
					$scope.tempIndustryIdArr.splice($scope.tempIndustryIdArr
							.indexOf(evt.item.label), 1);
					$scope.tempIndustryIdArr.splice($scope.tempIndustryIdArr
							.indexOf(evt.item.id), 1);
							//TaskId 51974
					if(arrayind.length < 0){
						$scope.indFlag = true;
					}
				} else if ($scope.industryall) {
					$scope.industryall = false;
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				} else if (indgri.getSelectedObjects().length > 1) {
					arrayind = [];
					arrayind.push("Multiple Industries selected");
				} else {
					arrayind = [];
					//TaskId 51974
					$scope.indFlag = true;
				}
			}

			$timeout(
					function() {
						$scope.selectedIndustries = angular.copy(arrayind);
						$scope.badgeStringInd = $scope.selectedIndustries
								.toString();
//
//						if ($scope.badgeStringind.length > 30) {
//							for (var i = 0; i < $scope.selectedIndustries.length; i++) {
//								if ($scope.selectedIndustries[i].length > 10) {
//									$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
//											.substr(0, 14)
//											+ '..';
//								}
//							}
//							$scope.badgeStringInd = $scope.selectedIndustries
//									.toString();
//						} else {
							$scope.badgeStringInd = $scope.selectedIndustries
									.toString();
						//}
					}, 100);
		}


		$scope.selectedType = 'INDUSTRY';
		$scope.status = {
			open : true
		};

		$scope.setSelectedType = function(type) {
			$scope.showResult = false;

			if ($scope.selectedType != type) {
				if (type == 'INDUSTRY') {
					if (prodgri != null) {
						prodgri.clearSelection();
						$scope.selectedProducts = [];
						$scope.selectAllprodflag = false;
						allKeysProducts = [];
						allKeysInd = [];
						arrayind = new Array();
						arrayprod = new Array();
					}
				} else if (type == "PRODUCT") {
					if (indgri != null) {
						indgri.clearSelection();
						allKeysProducts = [];
						allKeysInd = [];
						$scope.selectedIndustries = [];
						$scope.industryall = false;
						arrayind = new Array();
						arrayprod = new Array();
					}
				}
				$scope.selectedType = type;
			}
		}

		$scope.selectedranges = [];
		$scope.setlimit = function(selectedRange) {
			$scope.selectedranges = selectedRange;
		}

		$scope.showResult = false;
		$scope.getsearchData = function() {
			$scope.filterData.selectedType = $scope.selectedType;

			if ($scope.selectedType == 'INDUSTRY') {
				$scope.filterData.AllIndSelected = $scope.industryall;
				var industryids = [];
				$scope.filterData.industryids = industryids.toString();
			} else {
				var productids = [];
				$scope.filterData.AllIndSelected = $scope.selectAllflagprod;

			}
			if ($scope.selectedsegmentsfinal.length == 0) {
				if ($scope.selectedType == 'PRODUCT') {
					$scope.nosegdata = false;
				} else {
					$scope.nosegdata = true;
				}
			} else {
				$scope.filterData.selectedSegments = $scope.selectedsegmentsfinal
						.toString();
				$scope.filterData.tradingId = $scope.tradingId;
			}
			$scope.filterData.type = $scope.selectedType;
		}
		

		$scope.resetData = function() {
			$scope.noinddata = false;

			$scope.selectedranges = [];
			$scope.industryall = false;
			$scope.selectAllflagprod = false;

			$scope.selectedIndustries = [];
			if ($scope.selectedType == 'INDUSTRY') {
				for (var i = 0; i < $scope.sampleSegmentdata.length; i++) {
					$scope.sampleSegmentdata[i].chkval = false;
				}
				$scope.selectedsegmentsfinal = [];
			}

			indfiltervaluchanged = false;
			prodfiltervaluchanged = false;

			if (prodgri != null) {
				prodgri.collapseAll();
				prodgri.clearSelection();
				prodgri.clearAllFilters();
			}
			if (indgri != null) {
				indgri.collapseAll();
				indgri.clearSelection();
				indgri.clearAllFilters();
			}
			$scope.selectedProducts = [];
			$scope.selectedIndustries = [];

			arrayind = [];
			arrayprod = [];

			$scope.badgeStringProd = '';
			$scope.badgeStringInd = '';

			indfiltervaluchanged = false;
			firstcharind = '';
			prodfiltervaluchanged = false;
			firstcharprod = '';
			$scope.inactive = true;
			$scope.inactiveSlider = false;
			$scope.financialType1 = 'Revenue';
			$scope.radioresult = $scope.financialType1;
			$scope.resetCreditRating();
			if($scope.peerCompanyNames != undefined){
			$scope.peerCompanyNames.length = 0;
			}

		}

		$scope.getvalues = function() {
			$scope.industryProductDigestName = '';

			var indidspeer = [];
			if (industryGrid != null && industryGrid != "") {
				var peerGroupIndustryGridKeys = industryGrid.getSelectedObjects();
				ivhTreeviewBfs(peerGroupIndustryGridKeys, opts, function(node) {
					if (node.children.length == 0) {
						if (indidspeer.indexOf(node.id) == -1) {
							indidspeer.push(node.id);
						}
					}			
				});
			}
			$scope.selectedlocations = locidspeer.toString();
			$scope.newSelectedIndustries = indidspeer.toString();
			if ($scope.selectedType == 'INDUSTRY') {
				$scope.indPrdId = "";
				$scope.indPrdId = $scope.newSelectedIndustries;
			}

			if ($scope.selectedType == 'INDUSTRY') {
				if ($scope.tempIndustryNameArr.length != 0) {
					if ($scope.tempIndustryNameArr.length > 0
							&& $scope.tempIndustryNameArr.length < 4) {
						for (var i = 0; i < $scope.tempIndustryNameArr.length; i++) {

							if ($scope.industryProductDigestName == '') {
								$scope.industryProductDigestName += $scope.tempIndustryNameArr[i];
							} else {
								$scope.industryProductDigestName += ", "
										+ $scope.tempIndustryNameArr[i];
							}

						}
					} else if ($scope.tempIndustryNameArr.length >= 4) {
						$scope.industryProductDigestName = 'Multiple Industry Selected';
					}
				} else if ($scope.selectAllindustryflag == true) {
					$scope.industryProductDigestName = 'All Industry Selected';
				}
				//TaskId 51974
				if($scope.indFlag == true){
					$scope.iferrorpeerInd = true;
					$scope.errorpeerIndMessages = "Please select Industry.";
					$scope.validation = true;
					$timeout(function() {
						$scope.iferrorpeerInd = false;
						$scope.errorpeerIndMessages = "";
					}, 1000);
					return false;
				} else {
					$scope.iferrorpeerInd = false;
					$scope.validation = false;
				}
			}

		}
		
		
	
		// var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		// var optspeer = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		// var indidspeer = [];
		// 	if (indgri != null && indgri != "") {
		// 		var peerGroupIndustryGridKeys = indgri.getSelectedObjects();
		// 		ivhTreeviewBfs(peerGroupIndustryGridKeys, opts, function(node) {
		// 			if (node.children.length == 0) {
		// 				if (indidspeer.indexOf(node.id) == -1) {
		// 					indidspeer.push(node.id);
		// 				}
		// 			}			
		// 		});
		// 	}
		// $scope.reportType = $state.params.reportType;
		// $scope.canceler = $q.defer();
		// $scope.screenWidth = document.documentElement.clientWidth;
		// var industryGrid = null;
		// var arrayind = [];
		// $scope.selectedIndustries = [];
		// $scope.badgeStringind = '';
		// var indfiltervaluchanged = false;
		// $scope.setPeer = function() {
		// 	for (var index = 0; index < $scope.companyPeers.length; index++) {
		// 		if(index == 0) {
		// 			$scope.peerOneCompany = $scope.companyPeers[index];
		// 		} else if(index == 1) {
		// 			$scope.peerTwoCompany = $scope.companyPeers[index];
		// 		} else if(index == 2) {
		// 			$scope.peerThreeCompany = $scope.companyPeers[index];
		// 		}
		// 	}
		// 	$scope.savedPeerNames = $scope.companyPeers;
		// }
		// $scope.setPeer(); 
		// var indfiltervaluchanged = false;
		// var firstcharind = '';

		// $('#industrytreegrid').hide();
		// $scope.ind = {
		// 	indstatus : false
		// };
		// var click = 0;
		// var promise = GenericService.getMasterIndustryTreeDatascorecard();
		// promise.then(function (data) {
		// 	$scope.indTreeData = data;
		// }, function (response, status, headers, config) {
		// 	ErrorHandlerService.handleError(response, status, headers, config);
		// });

		// $scope.onindustryGridCreationCompleted = function(event) {

		// 	if (event != null) {
		// 		industryGrid = event.target;
		// 		industryGrid.enableHeightAutoAdjust = true;
		// 		industryGrid.setSelectionMode("singleRow");
		// 		industryGrid.validateNow();
		// 	} else {
		// 		industryGrid.enableHeightAutoAdjust = true;
		// 		industryGrid.clearFilter();
		// 		industryGrid.expandAll();
		// 		industryGrid
		// 				.setFilterValue('label', firstcharind, industryGrid);
		// 		industryGrid.validateNow();
		// 	}
		// };

		// $scope.gettooltipforIndustry = function(item, column) {
		// 	var html = "<label title='" + item.label + "'>" + item.label
		// 			+ "</label>"
		// 	return html;
		// };
		// $scope.disablecellind = function(cell, data) {
		// 	return (cell.getLevel().getNestDepth() != 5);
		// }
		// $scope.disablelevelind = function(cell, data) {
		// 	return data.children.length == 0;
		// }
		// $scope.filerPageSortHandle = function(event) {
		// 	setTimeout(
		// 			function() {

		// 				var filter = event.target.getRootFilter();
		// 				var grid = event.target;
		// 				if (!filter.filterExpressions.length) {
		// 					grid.collapseAll();
		// 					grid.validateNow();
		// 					indfiltervaluchanged = false;

		// 				}else{
		// 					grid.expandAll();
		// 				}
		// 				if (!indfiltervaluchanged) {
		// 					if (event.cause == "filterChange") {
		// 						if (filter.filterExpressions
		// 								&& filter.filterExpressions.length) {
		// 							firstcharind = filter.filterExpressions[0].expression
		// 							indfiltervaluchanged = true;
		// 							$scope
		// 									.onindustryGridCreationCompleted(null);
		// 						}
		// 					}
		// 				}
		// 			}, 1);
		// };
		// $scope.getIndustryTree = function () {
		// 	$scope.industryOptions = {
		// 		dataProvider: $scope.indTreeData,
		// 		delegate: $scope
		// 	};/* },100); */
		// }

		// $scope.setbadgesforindustry = function(evt) {

		// 	var grid = evt.target;
		// 	if (evt.isItemSelected) {
		// 		if (arrayind != null && arrayind != 'null') {
		// 			arrayind.splice(arrayind.indexOf(evt.item.label), 1);
		// 		}
		// 		$scope.noinddata = false;
		// 		arrayind.push(evt.item.label);
		// 		$scope.industryval = arrayind.length;
		// 		if ($scope.industryval > 0) {
		// 			$scope.iferrorindustry = false;
		// 		}
		// 		$scope.indFlag = false;
		// 	} else {
		// 		arrayind.splice(arrayind.indexOf(evt.item.label), 1);
		// 		if(arrayind.length() == 0){
		// 			$scope.indFlag = true;
		// 		}
		// 	}

		// 	$timeout(
		// 			function() {

		// 				$scope.selectedIndustries = angular.copy(arrayind);
		// 				$scope.badgeStringind = $scope.selectedIndustries
		// 						.toString();

		// 				if ($scope.badgeStringind.length > 30) {
		// 					for (var i = 0; i < $scope.selectedIndustries.length; i++) {
		// 						if ($scope.selectedIndustries[i].length > 10) {
		// 							$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
		// 									.substr(0, 14)
		// 									+ '..';
		// 						}
		// 					}
		// 					$scope.badgeStringind = $scope.selectedIndustries
		// 							.toString();
		// 				} else {
		// 					$scope.badgeStringind = $scope.selectedIndustries
		// 							.toString();
		// 				}

		// 			}, 100);

		// }

		// $scope.onIndustryDynamicLevelCreated = function(event) {
		// 	event.level.setEnableFooters(false);
		// 	if (event.level.getNestDepth() > 1) {
		// 		event.level.forcePagerRow = false;
		// 	} else {
		// 		event.level.forcePagerRow = true;
		// 	}
		// };
		// $scope.selectAllindustryflag = false;
		// $scope.selectAllindustry = function(flag) {
		// 	if(null != industryGrid){
				
		// 		industryGrid.collapseAll();
		// 		industryGrid.clearSelection();
		// 		industryGrid.clearAllFilters();

		// 		if (flag) {
		// 			arrayind = []
		// 			$scope.selectedIndustries = [];
		// 			var allkeys = [];
		// 			$scope.selectAllindustryflag = true;
		// 			ivhTreeviewBfs($scope.indTreeData, opts, function(node) {
		// 				allkeys.push(node.id);
		// 			});

		// 			$timeout(function() {
		// 				industryGrid.setSelectedKeys(allkeys, false);
		// 			}, 100);

		// 			industryGrid.setSelectedObjects($scope.indTreeData, false);

		// 		} else {
		// 			arrayind = [];
		// 			$scope.selectedIndustries = [];
		// 			$scope.selectAllindustryflag = false;
		// 			industryGrid.clearSelection();
		// 			indfiltervaluchanged = false;
		// 			industryGrid.collapseAll();
		// 			industryGrid.validateNow();
		// 		}
		// 	}
			
		// }

		
		$scope.selectCompanyPeerOne = function (companyObj) {
			if($scope.templateJson ? $scope.templateJson.template.peerBenchmarking : false) {
				$scope.savedPeers[0] = companyObj.companyCode;
			} else if($scope.reportType == '5' ) {
				$scope.savedPeers[0] = companyObj.companyCode;
			}
		}

		$scope.selectCompanyPeerTwo = function (companyObj) {
			if($scope.templateJson ? $scope.templateJson.template.peerBenchmarking : false) {
				$scope.savedPeers[1] = companyObj.companyCode;
			} else if($scope.reportType == '5' ) {
				$scope.savedPeers[1] = companyObj.companyCode;
			}
		}

		$scope.selectCompanyPeerThree = function (companyObj) {
			if($scope.templateJson ? $scope.templateJson.template.peerBenchmarking : false) {
				$scope.savedPeers[2] = companyObj.companyCode;
			} else if($scope.reportType == '5' ) {
				$scope.savedPeers[2] = companyObj.companyCode;
			}
		}
		
		$scope.selectCompanyPeerFour = function (companyObj) {
			if($scope.templateJson ? $scope.templateJson.template.peerBenchmarking : false) {
				$scope.savedPeers[3] = companyObj.companyCode;
			} else if($scope.reportType == '5' ) {
				$scope.savedPeers[3] = companyObj.companyCode;
			}
		}

		$scope.selectCompanyPeerFive = function (companyObj) {
			if($scope.templateJson ? $scope.templateJson.template.peerBenchmarking : false) {
				$scope.savedPeers[4] = companyObj.companyCode;
			} else if($scope.reportType == '5' ) {
				$scope.savedPeers[4] = companyObj.companyCode;
			}
		}

		$scope.savePeers = function() {
			if($scope.reportType == '5' ) {
				$scope.peerCodes = $scope.savedPeers;
			} else {
				$scope.templateJson.template.peerBenchmarking.peerGroup = $scope.savedPeers;
			}
			$scope.savedPeerNames[0] = $scope.peerOneCompany;
			$scope.savedPeerNames[1] = $scope.peerTwoCompany;
			$scope.savedPeerNames[2] = $scope.peerThreeCompany;
			if($scope.peerFourCompany) 
				$scope.savedPeerNames[3] = $scope.peerFourCompany;
			else {
				if($scope.savedPeerNames.length > 3) {
					$scope.savedPeerNames.splice(3, $scope.savedPeerNames.length - 3);
				}
			}
			if($scope.peerFiveCompany)
				$scope.savedPeerNames[4] = $scope.peerFiveCompany;
			$scope.remainigPeers = $scope.savedPeerNames.slice(1, $scope.savedPeerNames.length);
		}

		$scope.applyCrisilDefault = function() {
			var compDetails = JSON.parse(localStorage.getItem('companyDetails'))
			$scope.savedPeers = compDetails.peerCodes;
			//$scope.templateJson.template.peerBenchmarking.peerGroup = compDetails.peerCodes;
			var arr = compDetails.peersBenchmark.split('$');
			for (var index = 0; index < arr.length; index++) {
				if(index == 0) {
					$scope.peerOneCompany = arr[index];
				} else if(index == 1) {
					$scope.peerTwoCompany = arr[index];
				} else if(index == 2) {
					$scope.peerThreeCompany = arr[index];
				}
			}
			$scope.peerFourCompany = undefined;
			$scope.peerFiveCompany = undefined;
			$scope.showMorePeers = false;
		}

		$scope.$on('$destroy', function() {
			localStorage.removeItem('companyDetails');
			localStorage.removeItem('companyPeers');
		});

		$scope.cancelPeers = function() {
			$scope.peerOneCompany = $scope.savedPeerNames[0];
			$scope.peerTwoCompany = $scope.savedPeerNames[1];
			$scope.peerThreeCompany = $scope.savedPeerNames[2];
			if($scope.savedPeerNames[3]) {
				$scope.peerFourCompany = $scope.savedPeerNames[3];
			} else {
				$scope.peerFourCompany = '';
				$scope.savedPeers.splice(3, 1);
			}
			if($scope.savedPeerNames[4]) {
				$scope.peerFiveCompany = $scope.savedPeerNames[4];
			} else	{
				$scope.peerFiveCompany = '';
				$scope.savedPeers.splice(4, 1);
			}
		}
		$scope.peerOneNotFound = false;
		$scope.peerTwoNotFound = false;
		$scope.peerThreeNotFound = false;
		
		$scope.searchFilterForCompanyProfilePeerThree = function(typedthings) {
			$scope.peerThreeNotFound = false;
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					var obj  = {
						id: $scope.childIds.join(','),
						name: typedthings
					}
					CompanyReportService
					.getCompaniesByNameForPeers(obj)
					.then(function (data) {
							$scope.peerThreeNotFound = data.length == 0;
							$scope.companiesPeerThree = data;
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
		}
		$scope.searchFilterForCompanyProfilePeerOne = function(typedthings) {
			$scope.peerOneNotFound = false;
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					var obj  = {
						id: $scope.childIds.join(','),
						name: typedthings
					}
					CompanyReportService
					.getCompaniesByNameForPeers(obj)
					.then(function (data) {
							$scope.peerOneNotFound = data.length == 0;
							$scope.companiesPeerOne = data;
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
		}

		$scope.searchFilterForCompanyProfilePeerTwo = function(typedthings) {
			$scope.peerTwoNotFound = false;
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					var obj  = {
						id: $scope.childIds.join(','),
						name: typedthings
					}
					CompanyReportService
					.getCompaniesByNameForPeers(obj)
					.then(function (data) {
							$scope.peerTwoNotFound = data.length == 0;
							$scope.companiesPeerTwo = data;
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
		}

		$scope.searchFilterForCompanyProfilePeerFour = function(typedthings) {
			$scope.peerFourNotFound = false;
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					var obj  = {
						id: $scope.childIds.join(','),
						name: typedthings
					}
					CompanyReportService.getCompaniesByNameForPeers(obj)
					.then(function (data) {
							$scope.peerFourFound = data.length == 0;
							$scope.companiesPeerFour = data;
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
		}

		$scope.searchFilterForCompanyProfilePeerFive = function(typedthings) {
			$scope.peerFiveNotFound = false;
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					var obj  = {
						id: $scope.childIds.join(','),
						name: typedthings
					}
					CompanyReportService.getCompaniesByNameForPeers(obj)
					.then(function (data) {
							$scope.peerFiveFound = data.length == 0;
							$scope.companiesPeerFive = data;
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
		}

		$scope.downloadCustomReport = function () {
			$rootScope.disableGenerationButton = true;
			$scope.templateJson.companyCode = $scope.companyObj.companyCode;
			$scope.templateJson.companyName = $scope.companyObj.companyName;
			$scope.templateJson.financialsDataUnit = $scope.dataUnits;
			$scope.templateJson.financialsDataOrder = $scope.dataOrder;
			$scope.templateJson.irsIndCode=$scope.filters;
			$scope.templateJson.fsmAvailableFlag=$scope.isfsmAvFlag;
			$scope.templateJson.fsmExcelPath=$scope.excelPathForFsm;
			$scope.templateJson.fsmTemplatePath=$scope.fsmTemplatePath;
			if($scope.templateJson.template.crisilAnalytics) {
				$scope.templateJson.template.crisilAnalytics.consolidatedFlag = $scope.consolidationFlag;
			} 
			$scope.templateJson.reportFormat = parseInt($scope.selectedFormat);
			var url = 'api/companyProfile/getcustomjson'
			$rootScope.completionPercent = 0;
			var stop = $interval(function () {
				$rootScope.completionPercent = $rootScope.completionPercent + 1;
			}, 1500);
			$window.scroll(0, 0);
			$http({
				url: url,
				method: 'POST',
				data: $scope.templateJson,
				responseType: 'arraybuffer',
				ignoreLoadingBar: true,
				timeout: $scope.canceler.promise
			})
				.success(
					function (response, status, headers, config) {
						$scope.canceler.resolve(response);
						if ($scope.templateJson.reportFormat == 1) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.xlsx'
							var blob = new Blob(
								[response],
								{
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										templateName);
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/vnd.ms-excel'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
							}
						} else {
							if (headers('content-disposition').indexOf(
								'emptydoc') > -1) {
								$scope.contenterror = true;
								$scope.errorMessage = "No data available for the current selection";

								$timeout(function () {

									$scope.contenterror = false;
									$scope.errorMessage = [];

								}, 10000);
								$scope.cancel();
								return false;
							} else {
								if ($scope.templateJson.reportFormat == 2) {
									var isIE = false || !!document.documentMode;

									var blob = new Blob(
										[response], {
										type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

									});

									if (!isIE) {

										var anchor = angular.element('<a/>');
										var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
										anchor.css({
											display: 'none'
										});

										angular.element(document.body).append(
											anchor);
										// Attach to document

										anchor
											.attr({
												href: objectUrl,
												target: '_blank',
												download: 'Company_Report_for_' +
													$scope.companyObj.companyName +
													'.doc'
											})[0].click();

										anchor.remove();
									} else {

										window.navigator
											.msSaveOrOpenBlob(
												blob,
												'Company_Report_for_' +
												$scope.companyObj.companyName +
												'.doc');
									}
								} else {
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.pdf';
									var blob = new Blob(
										[response],
										{
											type: 'application/pdf'
										});
									if (isIE) {
										window.navigator
											.msSaveOrOpenBlob(
												blob,
												templateName);
									} else {
										var anchor = angular
											.element('<a/>');
										var blob = new Blob(
											[response],
											{
												type: 'application/pdf'
											})
										var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
										anchor.css({
											display: 'none'
										});
										angular.element(
											document.body)
											.append(anchor);
										anchor
											.attr({
												href: objectUrl,
												target: '_self',

												download: templateName
											})[0].click();

										anchor.remove();
									}
								}
							}
						}
						$rootScope.completionPercent = 100;
						$rootScope.disableGenerationButton = false;
						$state.go('companyreport');
						$interval.cancel(stop);
					}).error(function (response, status, headers, config) {
						$rootScope.completionPercent = 100;
						$rootScope.disableGenerationButton = false;
						$scope.error = false;
						$scope.errorMessage = "";
						$interval.cancel(stop);
						$scope.canceler.reject(response);
					})
		}
		

		$scope.downloadReport = function() {
			$rootScope.disableGenerationButton = true;
			$scope.peerCodes.unshift($scope.companyObj.companyCode);
			var company = {
				"companyCode" : $scope.companyObj.companyCode,
				"companyName": $scope.companyObj.companyName,
				"financialsDataUnit": $scope.dataUnits,
				"financialsDataOrder": $scope.dataOrder,
				"reportFormat": parseInt($scope.selectedFormat),
				"reportType": $scope.reportType,
				"irsIndCode" : $scope.filters,
				"fsmAvailableFlag": $scope.isfsmAvFlag,
				"fsmExcelPath": $scope.excelPathForFsm,
				"fsmTemplatePath": $scope.fsmTemplatePath,
				"scorecardFileName": $scope.scorecardFileName,
				"peerCodes": $scope.peerCodes,
				"interFirmConsolidated": 'N',
				"template": $scope.templateJson,
				"templateName": $scope.templateName
			}
			var url = company.reportFormat == 1 ? 'api/companyProfile/downloadExcelReportPhaseTwo' : 'api/companyProfile/generatereporttype' + $scope.reportType;
			$rootScope.completionPercent = 0;
			var stop = $interval( function(){ 
				$rootScope.completionPercent = $rootScope.completionPercent + 1;
			}, 1500);
			$window.scroll(0,0);
			$http({
					url : url,
					method : 'POST',
					data: company,
					responseType : 'arraybuffer',
					ignoreLoadingBar : true,
					timeout: $scope.canceler.promise
				})
				.success(
					function (response, status, headers, config) {
						$scope.canceler.resolve(response);
						if (company.reportFormat == 1) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.xlsx'
							var blob = new Blob(
								[response],
								{
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										templateName);
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/vnd.ms-excel'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
							}
						} else {
						if (headers('content-disposition').indexOf(
							'emptydoc') > -1) {
							$scope.contenterror = true;
							$scope.errorMessage = "No data available for the current selection";

							$timeout(function () {

								$scope.contenterror = false;
								$scope.errorMessage = [];

							}, 10000);
							$scope.cancel();
							return false;
						} else {
							 if (company.reportFormat == 2) {
								var isIE = false || !!document.documentMode;

								var blob = new Blob(
									[response], {
									type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

								});

								if (!isIE) {

									var anchor = angular.element('<a/>');
									var objectUrl = (window.URL || window.webkitURL)
										.createObjectURL(blob);
									anchor.css({
										display: 'none'
									});

									angular.element(document.body).append(
										anchor);
									// Attach to document

									anchor
										.attr({
											href: objectUrl,
											target: '_blank',
											download: 'Company_Report_for_' +
												$scope.companyObj.companyName +
												'.doc'
										})[0].click();

									anchor.remove();
								} else {

									window.navigator
										.msSaveOrOpenBlob(
											blob,
											'Company_Report_for_' +
											$scope.companyObj.companyName +
											'.doc');
								}
							} else {
								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var templateName = 'Company_Report_for_' + $scope.companyObj.companyName + '.pdf';
								var blob = new Blob(
									[response],
									{
										type: 'application/pdf'
									});
								if (isIE) {
									window.navigator
										.msSaveOrOpenBlob(
											blob,
											templateName);
								} else {
									var anchor = angular
										.element('<a/>');
									var blob = new Blob(
										[response],
										{
											type: 'application/pdf'
										})
									var objectUrl = (window.URL || window.webkitURL)
										.createObjectURL(blob);
									anchor.css({
										display: 'none'
									});
									angular.element(
										document.body)
										.append(anchor);
									anchor
										.attr({
											href: objectUrl,
											target: '_self',

											download: templateName
										})[0].click();

									anchor.remove();
								}
							}
						}
						}
						$rootScope.completionPercent = 100;
						$rootScope.disableGenerationButton = false;
						$state.go('companyreport');
						$interval.cancel(stop);
					}).error(function (response, status, headers, config) {
							$rootScope.completionPercent = 100;
							$rootScope.disableGenerationButton = false;
							$scope.error = false;
							$scope.errorMessage = "";
							$interval.cancel(stop);
							$scope.canceler.reject(response);
					})
		}

        $scope.generateCompanyReport = function() {
			CompanyReportService.checkEfexternalUser($scope.companyObj.companyCode).then(
				function(success) {
					$scope.message ={
						title: 'Generate Report',
						message: success.data,
						confirmation :true
					};
					$uibModal.open({
						templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
						size: 'sm',
						scope: $scope,
						controller: 'ConfirmationModalController'
					})

				}, function(error) {
						$scope.message ={
							state: 'fail',
							title: 'Report Generation Failed',
							message: error.data
						};
						$uibModal.open({
							templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
							size: 'sm',
							scope: $scope,
							controller: 'ConfirmationModalController'
						})
				}
			)
		}

        $scope.cancelReport = function() {
			$scope.canceler.resolve();
            $state.go('companyreport')
        }
		
		$scope.getTitle = function() {
			return ' +' + ($scope.companyPeers.length - 1)
		}

		$scope.getCompanyName = function() {
			return $scope.companyObj.companyName.indexOf('(') > 0 ? $scope.companyObj.companyName.split('(')[0] : $scope.companyObj.companyName;
		}

		$scope.addMorePeers = function() {
			$scope.showMorePeers = true;
		}

		$scope.getOpacity = function() {
			return $rootScope.disableGenerationButton ? '40%' : '100%';
		}
		
		$scope.chooseIrs = function(da){
			
			if(da != 'Select IRS Industry'){
				$scope.companyDetails.industryIrsScore = 'Y';
			}
		}

		$scope.fsmFunctiondata = function(){
			
		    if ($scope.fsmDataAll.length != 0) {

                $scope.companyCodeFsm = $scope.fsmDataAll[0].companyCode;
                $scope.listedFlagFsm = $scope.fsmDataAll[0].listedFlag;
                $scope.companyflagFsm = $scope.fsmDataAll[0].companyFlag;
                if ($scope.companyflagFsm != undefined && $scope.companyflagFsm != 'CREDIT') {
                    $scope.ybmFmsmFlag = 'Y';
                } else {
                    $scope.ybmFmsmFlag = 'N';
                }
                    if ($scope.listedFlagFsm != "" && $scope.listedFlagFsm != null && $scope.listedFlagFsm == "N") {
    					
    					 FinancialSensitivityUnlistedService
                    .getFinancialCompanyDataPresentOrNotForUnlisted($scope.companyCodeFsm, $scope.companyflagFsm)
                    .then(
                        function (result) {
    					 if (parseInt(result[0]) > 0) {
    					 if (result[4] == 'YAval' && result[5] == 'comAvl') {
    						 $scope.isfsmAvFlag = true;
    						$scope.consFlag= result[2];
    						$scope.indId = result[1];
    						
    						 $scope.dataToDownload = {
    					                exportObj: {
    					                    companyIndustryId: $scope.indId,
    					                    sensitivitySegmentId: result[3],
    					                    units: 'Crore',
    					                    companyCode: $scope.companyCodeFsm,
    					                    csDataFlag: $scope.consFlag,
    					                    consolidatedFlag: $scope.consFlag,
    					                    fmsmFlag: 'Y',
    					                    companyFlag:  $scope.companyflagFsm,
    					                    ybmFlag: $scope.ybmFmsmFlag

    					                }
    					            };
    					            var fd = new FormData();
    					            fd.append('dataToDownload', angular.toJson($scope.dataToDownload));
    					            FinancialSensitivityUnlistedService.financialSensitivityExportModelForUnlistedCIR(fd).then(function(res){
    					            	$scope.excelPathForFsm = res.excelPath;
    					            	$scope.fsmTemplatePath = res.fsmTemplatePath;
    					            	$scope.isfsmAvFlag = true;
    					            })
//    					            $http.post('api/financialSensitivityUnlisted/financialSensitivityExportModelForCIRUnlisted', fd, {
//    					                transformRequest: angular.identity
//    					             //   responseType: 'arraybuffer',
////    					                headers: {
////    					                    'Content-Type': undefined
////    					                }
//    					            }).success(
//    					                function (response) {
//    					                	$scope.excelPathForFsm = response.excelPath;
//    					                	$scope.fsmTemplatePath = res.fsmTemplatePath;
//    						            	$scope.isfsmAvFlag = true;
//    					                	
//    					                })
    					 }
    					 }else{
    						$scope.isfsmAvFlag = false;
    					 }
    					 
    					})
                    } else {
                        $scope.fmsmFlag = "N";
    					//var companyFlag = 'CREDIT';
                FinancialSensitivityService
                    .getFinancialCompanyDataPresentOrNot($scope.companyCodeFsm, $scope.companyflagFsm)
                    .then(
                        function (result) {
    					 if (parseInt(result[0]) > 0) {
    					  if (result[4] == 'YAval' && result[5] == 'comAvl') {
    						  $scope.isfsmAvFlag = true;
    					  $scope.consFlag= result[2];
    						$scope.indId = result[1];
    						
    						$scope.dataToDownload = {
					                exportObj: {
					                    companyIndustryId: $scope.selectedIndId != undefined ? $scope.selectedIndId : $scope.indId,
					                    sensitivitySegmentId: result[3],
					                    units: 'Crore',
					                    companyCode: $scope.companyCodeFsm,
					                    csDataFlag: $scope.consFlag,
					                    consolidatedFlag: $scope.consFlag,
					                    fmsmFlag: 'Y',
					                    companyFlag: $scope.companyflagFsm,
					                    ybmFlag: $scope.ybmFmsmFlag

					                }
					            };
					            var fd = new FormData();
					            fd.append('dataToDownload', angular.toJson($scope.dataToDownload));
    						
//    						$http.post('api/financialSensitivity/financialSensitivityExportModelForCIR', fd, {
//    		                    transformRequest: angular.identity,
//    		                    responseType: 'application/json',
//    		                    headers: {
//    		                        'Content-Type': undefined
//    		                    }
//    		                }).success(
//    		                    function (response) {
//    		                    	$scope.excelPathForFsm = response.excelPath;
//    		                    	$scope.isfsmAvFlag = true;
//    		                    	
//    		                    })
					            
					            FinancialSensitivityService.financialSensitivityExportModelForCIR(fd).then(function(res){
					            	$scope.excelPathForFsm = res.excelPath;
					            	$scope.fsmTemplatePath = res.fsmTemplatePath;
					            	$scope.isfsmAvFlag = true;
					            })
    					  }
    					 }else{
    						$scope.isfsmAvFlag = false;
    					 }
    					})
                    }
    				
    				
                    

                }else{
                	$scope.isfsmAvFlag = false;
                }

            
		}
		if($scope.reportType == '3' || ($scope.templateJson != undefined && $scope.templateJson.template.crisilAnalytics ? $scope.templateJson.template.crisilAnalytics.fsm : false)){
			$scope.fsmFunctiondata();
		}
		$window.scroll(0,0);
		
		$scope.$on("$destroy", function() {
			if($scope.reportType == 3 || $scope.reportType == 9) {
				CompanyReportService.deleteScorecardJsonFile($scope.scorecardFileName).then(
					function(success) {
					}, function(error) {}
				)
			}
		});
		$scope.$on('saveIndustryBenchmarkEvent', function(event, data) {
			$scope.templateJson.template.peerBenchmarking.industryBenchmarking = data;
		  });
    }
})();